<template>
  <a :href="route(url)" class="judging-shortcut">
    <div class="icon"><icon name="add" /></div>
    <div class="action">{{ action }}</div>
  </a>
</template>

<script>
import { route } from '@/lib/utils.js';
import Icon from '@/lib/components/Shared/Icon';

export default {
  components: {
    Icon
  },
  props: {
    url: {
      type: String,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  methods: {
    route
  }
};
</script>
